var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFb01 = function SvgSocialFb01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social_fb-01_svg2__a",
    x1: 14.65,
    x2: 204.65,
    y1: 190.73,
    y2: -11.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M188.96 0H11.03C4.94 0 0 4.95 0 11.04v177.93C0 195.06 4.95 200 11.04 200h95.8v-77.34H80.86V92.39h25.98V70.11c0-25.84 15.77-39.9 38.82-39.9 11.04 0 20.52.82 23.29 1.19v27h-15.89c-12.54 0-14.97 5.96-14.97 14.7v19.28h29.98l-3.91 30.27h-26.07v77.34h50.87c6.1 0 11.04-4.94 11.04-11.04V11.03C200 4.94 195.05 0 188.96 0",
    style: {
      fill: "url(#social_fb-01_svg2__a)"
    }
  }));
};
export default SvgSocialFb01;